import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../slice/authSlice";
import { Link } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import logo from "../../assets/image/logo.jpg";
import "./Navbar.css";
import { toast } from "react-hot-toast";

function Navbar() {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      toast.success("Logged out successfully!");
      navigate("/login");
    } catch (error) {
      toast.error("Logout failed. Please try again.");
    }
  };

  return (
    <div className="navbar">
      <div className="navbar-content">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo" />
        </Link>

        <div className="auth-buttons">
          {token === null ? (
            <>
              <Link to="/login">
                <button className="auth-button">Log in</button>
              </Link>
              <Link to="/signup">
                <button className="auth-button">Sign up</button>
              </Link>
            </>
          ) : (
            <>
              <Link to="/dashboard">
                <button className="auth-button">Dashboard</button>
              </Link>
              <button className="auth-button logout-button" onClick={handleLogout}>
                Log out
              </button>
            </>
          )}
        </div>
        <button className="menu-button">
          <AiOutlineMenu fontSize={24} />
        </button>
      </div>
    </div>
  );
}

export default Navbar;
